import { useState, useEffect } from "react";
import Dashboard from "./pages/Dashboard";
import AdminPage from "./pages/AdminPage";

export default function App() {
  const [page, setPage] = useState(
    window.location.hash === "#admin" ? "admin" : "dashboard"
  );

  useEffect(() => {
    const handler = () =>
      setPage(window.location.hash === "#admin" ? "admin" : "dashboard");
    window.addEventListener("hashchange", handler);
    return () => window.removeEventListener("hashchange", handler);
  }, []);

  return page === "admin" ? <AdminPage /> : <Dashboard />;
}
